export const SlideoutTestIds = {
  container: 'slideout-container',
  closeIcon: 'slideout-close-icon'
};

export const headerHeight = 80;
